<script lang="ts">
    import type { CustomerReviews } from '@shared/types/types.ts';

    interface Props {
        customerReviews: CustomerReviews | undefined;
    }

    type Stars = { name: 'rating-filled' | 'rating-half' | 'rating-empty' }[];
    let { customerReviews }: Props = $props();
    const maxRating = 5;

    let stars = $derived.by(() => {
        const stars: Stars = [];
        if (!customerReviews?.amount || !customerReviews?.averageRating) return stars;
        for (let i = 1; i <= maxRating; i++) {
            if (i <= customerReviews.averageRating) stars.push({ name: 'rating-filled' });
            else if (i - 0.5 == customerReviews.averageRating) stars.push({ name: 'rating-half' });
            else stars.push({ name: 'rating-empty' });
        }
        return stars;
    });
</script>

{#if stars.length > 0}
    <!-- NOTE: Sheets are defined globally in TileList.svelte -->
    <!-- SEE: src/tilelist/components/rating-sheets/RatingSheets.svelte -->
    <div class="reptile-rating" data-oc-sheet-v1-open data-oc-sheet-v1-open.id="reptile-ratings-sheet">
        <div class="reptile-rating__stars">
            {#each stars as star, i (i)}
                <oc-icon-v1 type={star.name} size={'50'}></oc-icon-v1>
            {/each}
        </div>
        <span class="reptile-rating__amount">({customerReviews?.amount})</span>
    </div>
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';

    .reptile-rating {
        cursor: pointer;

        display: flex;
        flex-wrap: wrap;

        width: 100%;

        font: tokens.$oc-semantic-font-copy-75;
        text-decoration: none;

        &__stars {
            display: inline-flex;
            gap: tokens.$oc-semantic-spacing-absolute-12;
            align-items: center;
            margin-right: tokens.$oc-semantic-spacing-absolute-12;
        }

        &__amount {
            color: tokens.$oc-semantic-color-text-secondary;
        }
    }
</style>
